import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PackageIcon, TagIcon, TrendingUpIcon } from 'lucide-react';
interface BrandCardProps {
  brand: {
    id: number;
    name: string;
    logo: string;
    category: string;
    productCount: number;
    discount: number;
    description: string;
    isFeatured: boolean;
  };
}
export function BrandCard({
  brand
}: BrandCardProps) {
  const navigate = useNavigate();
  return <div onClick={() => navigate(`/brand/${brand.name.toLowerCase().replace(/\s+/g, '-')}`)} className="bg-white rounded-xl shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden cursor-pointer group border border-gray-100" data-id="element-5421" data-mp="1ye3ifcdl1oen">
      {/* Logo Section */}
      <div className="relative bg-gray-50 p-6 h-40 flex items-center justify-center" data-id="element-5422" data-mp="2d2gj2mnm7vfh">
        {brand.isFeatured && <div className="absolute top-3 right-3 bg-yellow-400 text-[#1E2B55] px-3 py-1 rounded-full text-xs font-bold flex items-center gap-1" data-id="element-5423" data-mp="1fm0ztvhdry1r">
            <TrendingUpIcon className="w-3 h-3" data-id="element-5424" data-mp="2w30bimnm3qfw" />
            Featured
          </div>}
        <img src={brand.logo} alt={brand.name} className="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-300" data-id="element-5425" data-mp="2r3ns6bvy91i2" />
      </div>
      {/* Content Section */}
      <div className="p-4" data-id="element-5426" data-mp="2hct2syneplse">
        <h3 className="font-bold text-gray-900 mb-1 group-hover:text-[#1E2B55] transition-colors" data-id="element-5427" data-mp="2hbi0725p6k2v">
          {brand.name}
        </h3>
        <p className="text-xs text-gray-600 mb-3 line-clamp-1" data-id="element-5428" data-mp="28d5z2677g3w6">
          {brand.description}
        </p>
        {/* Stats */}
        <div className="flex items-center justify-between mb-3" data-id="element-5429" data-mp="23euplwktnveh">
          <div className="flex items-center gap-1 text-sm text-gray-600" data-id="element-5430" data-mp="1yeykfu0e1xxc">
            <PackageIcon className="w-4 h-4" data-id="element-5431" data-mp="1ygt5d8bntq1f" />
            <span data-id="element-5432" data-mp="1moq14x66ogn">{brand.productCount} Products</span>
          </div>
          {brand.discount > 0 && <div className="flex items-center gap-1 text-sm text-green-600 font-bold" data-id="element-5433" data-mp="3stsvhvdo22my">
              <TagIcon className="w-4 h-4" data-id="element-5434" data-mp="1r3afwzdny8wc" />
              <span data-id="element-5435" data-mp="1r291qm1cp6ae">Up to {brand.discount}% OFF</span>
            </div>}
        </div>
        {/* Shop Button */}
        <button className="w-full bg-[#1E2B55] text-white py-2 rounded-lg font-medium hover:bg-[#162041] transition-colors" data-id="element-5436" data-mp="1h5e92jrre041">
          Shop Now
        </button>
      </div>
    </div>;
}